import React from "react";
import { NavLink } from "react-router-dom"; // Add this import
import "./footer.css";
import maps from "../../assets/images/wold-maps-gtm.webp";
import insta from "../../assets/icons/insta.png";
import linkedin from "../../assets/icons/linkedin.png";
import tiktok from "../../assets/icons/tiktok.png";
import youtube from "../../assets/icons/youtube.png";
import { HiDevicePhoneMobile } from "react-icons/hi2";
import { GrLocation } from "react-icons/gr";
import { HiOutlineMail } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import RolexClock from "../rolex/RolexClock";

export default function Footer() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div className="text-sm">
      <div className="bg-black flex flex-col md:flex-row flex-wrap gap-6 sm:gap-10 md:gap-16 justify-center  px-6 md:px-20 py-10">
        <div className="flex flex-col justify-center items-center  gap-8">
          <div className="footer_titles text-xl font-semibold uppercase tracking-wider text-white">
            {t("footer.bureau")}
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11276.210596323188!2d-7.627780405180276!3d33.59028586390705!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7d32d2b853c79%3A0x873e063697531b82!2sGolf%20Trips%20Morocco!5e0!3m2!1sfr!2sma!4v1741620522141!5m2!1sfr!2sma"
            width="100%"
            height="300"
            className="md:w-[300px] md:h-[200px] rounded-lg shadow-lg"
            loading="lazy"
          ></iframe>
        </div>
        <div className="flex flex-col items-start  gap-8 ">
          <div className="footer_titles text-xl text-center w-full font-semibold uppercase tracking-wider text-white">
            <NavLink to="/Contact" className="text-white underline">
              {t("footer.contact")}
            </NavLink>
          </div>
          <div className="flex flex-col gap-3 h-full justify-center">
            <div className="flex gap-2 items-center">
              <HiDevicePhoneMobile size={22} color="white" />
              <span className="text-white">+212 668 942 099</span>
            </div>
            <div className="flex gap-2 items-center">
              <GrLocation size={22} color="white" />
              <span className="text-white">
                <div>{t("contact_us.loca.p1")}</div>
                <div>{t("contact_us.loca.p2")}</div>
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <HiOutlineMail color="white" size={22} />
              <span className="text-white">contact@gtm.ma</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 justify-center items-center self-center md:items-start pt-10 md:pt-0 h-full">
          <div className="text-white flex flex-col text-center md:text-left">
            <div>{t("footer.media")}</div>
          </div>
          <div className="flex gap-3">
            <a
              target="blank"
              className="cursor-pointer hover:opacity-75  "
              href="https://www.linkedin.com/company/golf-trips-morocco/"
            >
              <img width={25} src={linkedin} alt="LinkedIn" />
            </a>
            <a
              target="blank"
              className="cursor-pointer hover:opacity-75 "
              href="https://www.instagram.com/golftripsmorocco"
            >
              <img width={25} src={insta} alt="Instagram" />
            </a>

            <a
              target="blank"
              className="cursor-pointer hover:opacity-75 "
              href="https://www.tiktok.com/@golf_trips_morocco"
            >
              <img width={25} src={tiktok} alt="TikTok" />
            </a>
            <a
              target="blank"
              className="cursor-pointer hover:opacity-75"
              href="https://www.youtube.com/@GolfTripsMorocco"
            >
              <img width={25} src={youtube} alt="YouTube" />
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white p-4 flex flex-col md:flex-col gap-1 md:gap-2 justify-center  items-center text-center mb-[6rem]    md:mb-[1rem]">
        <div className="">
          <span>
            Copyright © 2025{" "}
            <span className="font-bold text-[17px] text-[#00573f]">
              Golf Trips Morocco
            </span>{" "}
            | {t("footer.copyright")}
          </span>
          <NavLink to="https://mzlouafi.com/" className="font-semibold">
            MZ LOUAFI SARL
          </NavLink>
        </div>
        <p className="font-bold"> V.3.9.0</p>
      </div>

      <div className="fixed bottom-0 w-full left-0 z-50 flex items-center justify-center custom:hidden">
        {/* Background layer */}
        <div className="absolute  bg-white"></div>

        {/* Iframe with slight transparency (if possible) */}
            <RolexClock style="w-full h-[95px] bg-opacity-[80%]"/>

        {/* <iframe
          className="embed-responsive-item rolex h-[80px] w-[100vw] opacity-90"
          src="https://static.rolex.com/clocks/2018/ladieseuropeantour_desktop_HTML_270x90/rolex.html"
          allowFullScreen
          scrolling="no"
          frameBorder="0"
        ></iframe> */}
      </div>
    </div>
  );
}
